import BadgeT from '@components/tailwind-components/Badge/BadgeT';
import type { KnowledgeArticleDTO } from '@conversed/rest/src/contracts/article-architect/article-architect.dto';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { getArticleBadgeColors } from './article-architect.config';

export const ArticleSourceBadge: React.FC<{ article: KnowledgeArticleDTO }> = ({
  article,
}) => {
  const { t } = useTranslation();
  const { sourceColors } = getArticleBadgeColors(article);
  if (!sourceColors) {
    return null;
  }
  return (
    <BadgeT
      text={t(`article-architect.articles-tab.source.${article.sourceType}`)}
      bgColorHex={sourceColors.bgColor}
      fontColorHex={sourceColors.textColor}
      shouldOverrideTextSize
      className='text-tiny !font-medium'
    />
  );
};

export const ArticleStatusBadge: React.FC<{ article: KnowledgeArticleDTO }> = ({
  article,
}) => {
  const { t } = useTranslation();
  const { statusColors } = getArticleBadgeColors(article);
  return (
    <BadgeT
      text={t(`article-architect.articles-tab.status.${article.status}`)}
      bgColorHex={statusColors.bgColor}
      fontColorHex={statusColors.textColor}
      shouldOverrideTextSize
      className='text-tiny !font-medium'
    />
  );
};

export const ArticleCategoryBadge: React.FC<{
  article: KnowledgeArticleDTO;
}> = ({ article }) => {
  const { categoryColors } = getArticleBadgeColors(article);
  if (!article.category) {
    return null;
  }
  return (
    <BadgeT
      text={article.category}
      bgColorHex={categoryColors.bgColor}
      fontColorHex={categoryColors.textColor}
      shouldOverrideTextSize
      className='text-tiny !font-medium'
    />
  );
};
